import { Checkbox, InputProps } from 'antd';
import TcInput from 'components/UI/form/input/TcInput';
import TcFormItem from 'components/UI/form/TcFormItem';
import { useState } from 'react';

interface TcInputNationalIDProps {
  name?: string;
  foreignName?: string;
  required?: boolean;
  inputProps?: InputProps;
}

const TcInputNationalID: React.FC<TcInputNationalIDProps> = ({ name = 'nationalId', foreignName = 'fidaCode', required = false, inputProps = {} }) => {
  const [isForeign, setIsForeign] = useState(false);

  const validateId = (_: any, value: string) => {
    // if empty, let the "required" rule handle it (or allow empty if not required)
    if (!value) {
      return Promise.resolve();
    }

    if (isForeign) {
      // foreign IDs ("کد فراگیر") must be exactly 11 digits
      if (!/^\d{11}$/.test(value)) {
        return Promise.reject(new Error('کد فراگیر باید دقیقا 11 رقم باشد'));
      }
      return Promise.resolve();
    }

    // domestic national ID: exactly 10 digits + checksum
    if (!/^\d{10}$/.test(value)) {
      return Promise.reject(new Error('کد ملی باید دقیقا 10 رقم باشد'));
    }

    const check = +value[9];
    const sum = [...value].slice(0, 9).reduce((acc, digit, idx) => acc + +digit * (10 - idx), 0);
    const remainder = sum % 11;
    const isValid = (remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder);

    if (!isValid) {
      return Promise.reject(new Error('کد ملی وارد شده نامعتبر است'));
    }

    return Promise.resolve();
  };

  return (
    <TcFormItem
      name={isForeign ? foreignName : name}
      label={isForeign ? 'کد فراگیر' : 'کدملی'}
      extra={
        <Checkbox checked={isForeign} onChange={(e) => setIsForeign(e.target.checked)} className='text-xs'>
          اتباع خارجی هستم
        </Checkbox>
      }
      rules={[
        {
          required,
          message: `${isForeign ? 'کد فراگیر' : 'کدملی'} را وارد کنید.`,
        },
        {
          validator: validateId,
        },
      ]}
      hasFeedback>
      <TcInput placeholder={isForeign ? 'کد فراگیر' : 'کدملی'} maxLength={isForeign ? 11 : 10} {...inputProps} />
    </TcFormItem>
  );
};

export default TcInputNationalID;
